import api from '@/api';
import utilsActions from '@/utils/actions';

export default {
    namespaced: true,
    state: {
        list: [],
        error: null,
        errors: null,
        requestPending: false,
    },
    getters: {
        getById: (state) => (id) => state.list.find((item) => item.id === id),
    },
    mutations: {
        setList(state, list) {
            state.list = list;
        },
        clearError(state) {
            state.error = null;
        },
        setError(state, error) {
            state.error = error;
        },
        clearErrors(state) {
            state.errors = null;
        },
        setErrors(state, errors) {
            state.errors = errors;
        },
        startRequest(state) {
            state.requestPending = true;
        },
        endRequest(state) {
            state.requestPending = false;
        },
    },
    actions: {
        async list(context) {
            await utilsActions.defaultAction(context, api.checklists.list(), (data) => {
                context.commit('setList', data.data);
            });
        },
        async create(context, { element, files }) {
            for (let i = 0; i < element.items.length; i += 1) {
                element.items[i].order = i;
            }

            await utilsActions.defaultAction(context, api.checklists.create(element, files));
        },
        async update(context, { element, files }) {
            for (let i = 0; i < element.items.length; i += 1) {
                element.items[i].order = i;
            }

            await utilsActions.defaultAction(context, api.checklists.update(element.id, element, files));
        },
        async remove(context, id) {
            await utilsActions.defaultAction(context, api.checklists.remove(id));
        },
    },
};
